export default __webpack_public_path__ + "static/media/sellers.70bc5bf7.png";